<div>
  <canvas baseChart [data]="doughnutData" type="doughnut">
  </canvas>
</div>
